import { SharedModule } from './shared.module';
import { InterceptorService } from './shared/interceptor/interceptor.service';
import { HeaderBodyFooterAdderComponent } from './theme/header-body-footer-adder/header-body-footer-adder.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CommonModule } from '@angular/common';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injectable, ErrorHandler } from '@angular/core';
import { JwtModule } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
// import * as Sentry from '@sentry/browser';

import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { NgProgressModule } from '@ngx-progressbar/core';




import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { HttpErrorComponent } from './static-pages/http-error/http-error.component';
import { HttpComponent } from './static-pages/http/http.component';
import { directLiginComponent } from './static-pages/direct-login/direct-login.component';




export function tokenGetter() {
  return localStorage.getItem('access_token');
}

// Sentry.init({
//   dsn: environment.sentry_dsn
// });

// @Injectable()
// export class SentryErrorHandler implements ErrorHandler {
//   constructor() {}
//   handleError(error) {
//     Sentry.captureException(error.originalError || error);
//     throw error;
//   }
// }


@NgModule({
  declarations: [
    AppComponent,
    HeaderBodyFooterAdderComponent,
    PageNotFoundComponent,
    HttpErrorComponent,
    HttpComponent,
    directLiginComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    NgSelectModule,
    BrowserAnimationsModule,
    FormsModule,
    SharedModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    NgProgressModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: ['http://dev-api.apprenticeshipindia.org'],
        blacklistedRoutes: ['http://dev-api.apprenticeshipindia.org']
      }
    }),
    RecaptchaModule,
    RecaptchaFormsModule
  ],
  providers: [
    Title,
   //  { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    CookieService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey
      } as RecaptchaSettings,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
